import { createElement } from 'react';
import { Tabs } from '@bedrock/components';
const LcTabs = function LcTabs(props) {
    console.log('props: ', props);
    const { TabPane } = Tabs;
    const Content = ({ children }) => createElement("div", { className: "p-5 bg-n10 text-n70" }, children);
    return (createElement(Tabs, { defaultActiveKey: "1", onChange: console.log },
        createElement(TabPane, { tab: "\u9009\u9879\u4E00", key: "1" },
            createElement(Content, null, "\u9009\u9879\u4E00\u5185\u5BB9")),
        createElement(TabPane, { tab: "\u9009\u9879\u4E8C", key: "2" },
            createElement(Content, null, "\u9009\u9879\u4E8C\u5185\u5BB9")),
        createElement(TabPane, { tab: "\u9009\u9879\u4E09", key: "3" },
            createElement(Content, null, "\u9009\u9879\u4E09\u5185\u5BB9")),
        createElement(TabPane, { tab: "\u9009\u9879\u56DB", key: "4" },
            createElement(Content, null, "\u9009\u9879\u56DB\u5185\u5BB9")),
        createElement(TabPane, { tab: "\u9009\u9879\u4E94", key: "5", disabled: true },
            createElement(Content, null, "\u9009\u9879\u4E94\u5185\u5BB9"))));
};
export default LcTabs;
